/** Compute the date of Easter Sunday (Gregorian calendar) */
function easterSunday(year: number): Date {
  // Meeus/Jones/Butcher algorithm
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  // Use UTC to avoid timezone shifts
  return new Date(Date.UTC(year, month - 1, day));
}

function addDaysUTC(d: Date, days: number): Date {
  const copy = new Date(d.getTime());
  copy.setUTCDate(copy.getUTCDate() + days);
  return copy;
}

function isoUTC(d: Date): string {
  // Return YYYY-MM-DD
  return d.toISOString().slice(0, 10);
}

type Options = {
  /** Include Alsace-Moselle specific holidays (Good Friday, December 26th) */
  includeAlsaceMoselle?: boolean;
};

/**
 * Returns the list of French public holidays for `year`, formatted as 'YYYY-MM-DD'.
 * Includes moveable holidays (Easter Monday, Ascension, Whit Monday).
 */
export function frenchHolidays(year: number, opts: Options = {}): string[] {
  const { includeAlsaceMoselle = false } = opts;

  // Fixed-date holidays (same date every year)
  const fixed = [
    `${year}-01-01`, // New Year's Day
    `${year}-05-01`, // Labour Day
    `${year}-05-08`, // Victory 1945
    `${year}-07-14`, // Bastille Day
    `${year}-08-15`, // Assumption
    `${year}-11-01`, // All Saints' Day
    `${year}-11-11`, // Armistice Day
    `${year}-12-25`, // Christmas
  ];

  // Easter Sunday
  const easter = easterSunday(year);

  // Moveable holidays (computed from Easter)
  const easterMonday = addDaysUTC(easter, 1); // Easter Monday
  const ascension = addDaysUTC(easter, 39); // Ascension Thursday
  const pentecostMo = addDaysUTC(easter, 50); // Whit Monday

  const mobile = [easterMonday, ascension, pentecostMo].map(isoUTC);

  // Alsace-Moselle specific holidays (optional)
  const alsace: string[] = [];
  if (includeAlsaceMoselle) {
    const goodFriday = addDaysUTC(easter, -2); // Vendredi saint
    alsace.push(isoUTC(goodFriday));
    alsace.push(`${year}-12-26`); // Saint Étienne
  }

  // Merge + sort for readability (optional)
  const all = [...fixed, ...mobile, ...alsace];
  all.sort(); // lexicographical sort YYYY-MM-DD

  return all;
}
